const unavailable = 'The contact form is temporarily unavailable. Please email info@codexsolutions.io.';

export async function readContactResponse(response) {
  if (response.status === 404 || response.status === 405) {
    throw new Error('The contact form is not connected to the email service. Please email info@codexsolutions.io.');
  }
  let result;
  try { result = await response.json(); }
  catch { throw new Error(unavailable); }
  if (!result || typeof result !== 'object') {
    throw new Error(unavailable);
  }
  if (!response.ok || result.ok === false) {
    throw new Error(typeof result.error === 'string' ? result.error : unavailable);
  }
  if (result.ok !== true) throw new Error(unavailable);
  return result;
}
